import { LoadSpinner } from '@calizahq/react-components-v2'
import {
  SortBy,
  usePotentialBookingFiltersContext,
} from '@sales-app/context/potentialBookingFilters/potentialBookingFilters'
import { usePotentialBookings } from '@sales-app/hooks/usePotentialBookings/usePotentialBookings'
import { BottomBar } from '@sales-app/views'
import { Row } from '@tanstack/react-table'
import React, { useMemo, useState } from 'react'

import { Table } from '@/components'
import { useUserContext } from '@/context'
import { AgentRoles } from '@/context/user/user.types'

import { FilterBar } from './FilterBar'
import { AssignFilter } from './Filters/AssignFilter'
import { PotentialBookingsColumns, transformedPotentialBooking } from './PotentialBookings.data'
import { UpdateStatusSelection } from './UpdateStatusSelection'

export const PotentialBookings = () => {
  const { data: potentialBookingData, isLoading } = usePotentialBookings()
  const { sortBy, setSortBy } = usePotentialBookingFiltersContext()
  const data = useMemo(() => {
    return potentialBookingData?.potentialBookings
      ? transformedPotentialBooking(potentialBookingData?.potentialBookings)
      : []
  }, [potentialBookingData])

  const [rowSelected, setRowSelection] = useState<Row<any>[]>([])

  const columns = useMemo(() => {
    return PotentialBookingsColumns
  }, [])

  const setSortBySelection = (selectedSortBy: SortBy[]) => {
    if (selectedSortBy && selectedSortBy.length) {
      setSortBy(selectedSortBy[0])
    } else {
      sortBy && setSortBy(null)
    }
  }

  const { user } = useUserContext()
  const isSupervisor = user?.agent?.role === AgentRoles.SUPERVISOR || user?.isSuperAdmin

  return (
    <>
      <div className="flex w-full flex-col p-4 md:p-8">
        <div className="mb-2 flex w-full items-center justify-between md:mb-4 md:flex-row">
          <h2 className=" text-header-lg leading-120">Potential Bookings</h2>

          {isSupervisor && (
            <div className="hidden md:flex">
              <AssignFilter rowSelected={rowSelected} />
              <UpdateStatusSelection rowSelected={rowSelected} />
            </div>
          )}
        </div>

        <FilterBar />
        {isLoading ? (
          <div className="flex h-20 w-full items-center justify-center">
            <LoadSpinner className="icon-secondary" isCurrentColor={true} size={2} />
          </div>
        ) : (
          <>
            <Table
              columns={columns as any}
              data={data}
              disableSortBy={false}
              manualSortBy={true}
              rowSelection={isSupervisor}
              setRowSelection={setRowSelection}
              setSortBySelection={setSortBySelection}
            />
          </>
        )}
      </div>
      <BottomBar />
    </>
  )
}
